import { TextControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

export const VayuBlocksTextControl = (props) => {
  return (
    <TextControl
      className="vb-image-alt-text-control"
      __nextHasNoMarginBottom={true}
      __next40pxDefaultSize={true}
      {...props}
    />
  );
};
